module.exports = __webpack_public_path__ + "b0fbbe7a27c50469dff5408f827a5d31.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/chevron_right.svg
// module id = 35
// module chunks = 0